import { JBaseApi } from '../base';
import { OF } from '../../util/network';
import { AseiGroups, AseiRights, AseiTicket, AseiTicketStatus } from '../../types/asei';
import { ApiWrapper, Filters, Orders, PagingResults } from '../../types/utils';

export class JAseiApi extends JBaseApi {
    /**
     * List Asei Clearance Tickets
     * @param page page number
     * @param limit number of elements per page
     * @param filters filter object
     * @param orders order object
     */
    public list(
        page: number,
        limit: number,
        filters?: Filters,
        orders: Orders = [{ name: 'dateCreation', sort: 'DESC' }],
    ): Promise<ApiWrapper<PagingResults<AseiTicket>>> {
        return this.jApi.article.list<AseiTicket>({
            type: 'aseiClearanceTicket',
            format: 'raw-view',
            limit,
            page,
            orders,
            filters,
        });
    }

    /**
     * change status of an Asei Ticket
     */
    public requestStatus(
        uri: string,
        requestedStatus: AseiTicketStatus,
        audience?: Array<string>,
    ): Promise<ApiWrapper<AseiTicket>> {
        return this.network.post<AseiTicket>({ o: 'asei', f: 'setStatus', uri, requestedStatus, audience } as OF);
    }

    /**
     * Get asei dedicated groups (dsi, administrators)
     */
    public getDedicatedGroups(): Promise<ApiWrapper<AseiGroups>> {
        return this.network.post<AseiGroups>({ o: 'asei', f: 'getDedicatedGroups' } as OF);
    }

    /**
     * Get asei configuration (rights to access, rights to publish)
     */
    public getConfiguration(): Promise<ApiWrapper<{ right: AseiRights }>> {
        return this.network.post<{ right: AseiRights }>({ o: 'asei', f: 'configuration' });
    }
}
